import { privateRoutes } from '~constants/routes'

export const getIsRoutePrivate = (path: string) => {
    try {
        /**
         * Starts with /${appRoute.app}/${route}
         * excluding /${appRoute.app}/${route}66-or-something
         */
        return privateRoutes.find(route => new RegExp(`^\\/${route}($|\\/)`).test(path))
    } catch (e) {
        return false
    }
}
